import { RequestService } from '../../../../../common/services/RequestService';
import { dataAdjustmentResponse } from './dataAdjustment';
import { GET_ALL_VEHICLES } from '../../constants';

export const getAllVehiclesRequest = async (profileId, payload) => {
  const response = await RequestService.get(
    GET_ALL_VEHICLES.replace('{profile_id}', profileId),
    {
      params: {
        serviceTypeRestrictionKey: payload && payload.serviceType || null
      }
    }
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(vehicle => dataAdjustmentResponse(vehicle))
  );
};
